import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TalkService } from '../talk.service';
import Talk from "talkjs";
import { OnboardingService } from '../onboarding.service';
import { UserDetailsService } from 'src/app/core/services/user-details/user-details.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-my-inbox',
    templateUrl: './my-inbox.component.html',
    styleUrls: ['./my-inbox.component.scss']
})
export class MyInboxComponent implements OnInit, AfterViewInit {
    private inbox: Talk.Inbox;
    private session: Talk.Session;
    private popup: Talk.Popup;

    constructor(private talkService: TalkService,
        private onboardingService: OnboardingService,
        private service: UserDetailsService,
        private dialog: MatDialog) { }

    ngOnInit(): void {
        // this.openDialogWithoutRef()

        this.service.getShowcases().subscribe((response: any) => {
            this.service.getUserDetails(response.user).subscribe((res: any) => {
                console.log(res)
                this.onboardingService.userProfileDetails = res;
                this.onboardingService.userProfileDetails['id'] = response.user;
                this.createInbox();
            })
        })

    }

    private async createInbox() {

        const session = await this.talkService.createCurrentSession();
        this.popup = session.getPopups()[0]
        if ( this.popup) {
            this.popup.destroy()
        }
        const inbox = session.createInbox();
       // inbox.setFeedFilter( {subject: ["!=", "Red Carpet"]} );
       // inbox.setFeedFilter( {custom:{ category: "!exists" }})
        inbox.mount(document.getElementById('talkjs-container'));
        if (inbox) {
            this.dialog.closeAll()
        }
    }

    ngAfterViewInit(): void {
        console.log(this.onboardingService.userProfileDetails)
    }

    openDialogWithoutRef() {
        // this.dialog.open(this.progessDialog, { disableClose: true });
    }
}
